/** Used only when a tier has no `term_months` from prequal (should be rare). */
export const DEFAULT_PREQUAL_TERM_MONTHS: number[] = [36, 48, 60];

export function tierTermMonthsOrDefault(termMonths: number[] | null | undefined): number[] {
  if (Array.isArray(termMonths) && termMonths.length > 0) {
    return termMonths;
  }
  return [...DEFAULT_PREQUAL_TERM_MONTHS];
}
